import { state } from '@/store/breadcrumb/state';
import { getters } from '@/store/breadcrumb/getters';
import { actions } from '@/store/breadcrumb/actions';
import { mutations } from '@/store/breadcrumb/mutations';

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export { state, getters, mutations, actions };
